const KEY_X_API_KEY = "X-API-KEY";
const KEY_IS_NEW_USER = "IS_NEW";

export const getJWTLocalStorage = (): string | null => {
  const res = window.localStorage.getItem(KEY_X_API_KEY);
  return res ?? null;
}

export const setXApiKeyLocalStorage = (value: string) => {
  window.localStorage.setItem(KEY_X_API_KEY, value);
}

export const removeJWTLocalStorage = () => {
  window.localStorage.removeItem(KEY_X_API_KEY);
}

export const getIsNewUserLocalStorage = (): string | null => {
  const res = window.localStorage.getItem(KEY_IS_NEW_USER);
  return res ?? null;
}

export const setIsNewUserLocalStorage = (value: string) => {
  window.localStorage.setItem(KEY_IS_NEW_USER, value);
}

export const removeIsNewUserLocalStorage = () => {
  window.localStorage.removeItem(KEY_IS_NEW_USER);
}
